import React, { useState } from "react";
import { Table, Empty, Button, Row, Col, Modal, message } from "antd";
import ViewReportListHeader from "../../../components/Pms/ViewReportList/ViewReportListHeader";
import { CardElement, HomePageTable } from "../../../components/Common";
import {
  useGetPMS,
  useGetReportListByPMS,
  useDeactivatePMSReport,
} from "../../../hooks/pms.hooks";
import AddPMSReport from "../AddPMSReport/AddPMSReport";
import BreadCrumb from "../../../components/Breadcrumb";
import { tableStringSorter } from "../../../utils/table";
import BulkPMSReportFormElement from "../../../components/BulkCreation/BulkPMSReportCreation/BulkPMSReportFormElement";

const { confirm } = Modal;

const ViewPMSReportList = () => {
  const [pmsId, setPmsId] = useState(null);
  const [reportData, setReportData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationSize, setPaginationSize] = useState(10);
  const [dromoData, setDromoData] = useState();

  const { isLoading: isLoadingPMS, data: pmsData } = useGetPMS();

  const {
    data: reportsData,
    isLoading: reportLoading,
    refetch: refetchReports,
  } = useGetReportListByPMS(pmsId, {
    enabled: !!pmsId,
    select: (data) => {
      const updatedData = [...data];
      return updatedData.map((e) => {
        return {
          ...e,
          create_by: e?.create_by?.name ?? "",
          update_by: e?.update_by?.name ?? "",
        };
      });
    },
  });

  const { mutate: deactivePMSReport } = useDeactivatePMSReport({
    onSuccess: () => {
      message.success("PMS Report Deactivated Successfully");
      refetchReports();
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const openReportModal = (record) => {
    setReportData({ ...record, pms: pmsId });
  };

  const columns = [
    {
      title: "No",
      key: "index",
      width: "50px",
      render: (_, __, index) => (currentPage - 1) * paginationSize + index + 1,
    },
    {
      title: "myDocs Report Name",
      dataIndex: "mydocs_report_name",
      key: "mydocs_report_name",
      width: "250px",
      sorter: tableStringSorter("mydocs_report_name"),
    },
    {
      title: "PMS Report Name",
      dataIndex: "report_name",
      key: "report_name",
      width: "250px",
      sorter: tableStringSorter("report_name"),
    },
    {
      title: "Report Code/Spooler Code",
      dataIndex: "report_code",
      key: "report_code",
      width: "250px",
      sorter: tableStringSorter("report_code"),
    },
    {
      title: "Primary Submission Method",
      dataIndex: "source_type",
      key: "source_type",
      width: "250px",
      sorter: tableStringSorter("source_type"),
    },
    {
      title: "myDocs Report Type",
      dataIndex: "mydocs_report_type",
      key: "mydocs_report_type",
      width: "250px",
      sorter: tableStringSorter("mydocs_report_type"),
    },
    {
      title: "File Name",
      dataIndex: "file_name",
      key: "file_name",
      width: "250px",
      sorter: tableStringSorter("file_name"),
    },
    {
      title: "Created By",
      dataIndex: "create_by",
      key: "create_by",
      width: "200px",
      sorter: tableStringSorter("create_by"),
    },
    {
      title: "Updated By",
      dataIndex: "update_by",
      key: "update_by",
      width: "200px",
      sorter: tableStringSorter("update_by"),
    },
    {
      title: "Operation",
      dataIndex: "update_by",
      key: "update_by",
      width: "180px",
      fixed: "right",
      render: (_, record) => {
        return (
          <Row justify="space-between">
            <Col span={6}>
              <Button
                onClick={() => showModal(record)}
                type="link"
                disabled={!record.status}
              >
                Deactivate
              </Button>
            </Col>
            <Col span={6}>
              <Button
                onClick={() => openReportModal(record)}
                type="link"
                disabled={!record.status}
              >
                Edit
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  let tableHeight = 700;
  if (window.innerWidth > 700) {
    tableHeight = window.innerHeight - 375;
  }

  const showModal = (record) => {
    confirm({
      title: "Deactivate Report",
      icon: null,
      width: 550,
      content: (
        <p>
          Are you sure you want to deactivate the
          <b> {record.report_name} </b>
          report?
        </p>
      ),
      okText: "Yes",
      cancelText: "No",
      onOk() {
        deactivePMSReport(record._id);
      },
    });
  };

  const getReportsById = (id) => {
    if (id === pmsId) refetchReports();
    else setPmsId(id);
  };

  const dromoResultHandler = (data) => {
    if (data && data.length > 0) {
      setDromoData(data);
    }
  };

  return (
    <div>
      <div className="container_aa">
        <h3>Report List by PMS</h3>
        <BreadCrumb
          routes={[
            { path: "/home", breadcrumbName: "Dashboard" },
            {
              path: "/pms/report-list",
              breadcrumbName: "PMS Standard Report List",
            },
          ]}
        />
      </div>
      <CardElement>
        <>
          <ViewReportListHeader
            getPMSReportData={getReportsById}
            pmsData={pmsData}
            loading={isLoadingPMS}
            reportLoading={reportLoading}
            refetchReports={refetchReports}
            dromoResultHandler={dromoResultHandler}
            pmsId={pmsId}
          />
          {reportsData === undefined ? (
            <Empty description="Please select your filters and click the Go button" />
          ) : (
            <div>
              {reportsData && reportsData.length > 0 ? (
                <HomePageTable>
                  <Table
                    className=""
                    columns={columns}
                    dataSource={reportsData}
                    rowKey="_id"
                    scroll={{ x: 1100, y: tableHeight }}
                    pagination={{
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "25", "50", "100"],
                      onChange(current, pageSize) {
                        setCurrentPage(current);
                        setPaginationSize(pageSize);
                      },
                    }}
                  />
                </HomePageTable>
              ) : (
                <Empty description="No PMS Report Found" />
              )}
            </div>
          )}
        </>
        <AddPMSReport
          open={!!reportData?._id}
          setOpen={setReportData}
          refetchReports={refetchReports}
          editData={reportData}
          disable
        />
        <BulkPMSReportFormElement
          reportData={dromoData}
          setOpen={setDromoData}
        />
      </CardElement>
    </div>
  );
};

ViewPMSReportList.propTypes = {};

export default ViewPMSReportList;
